import { useEffect, useState } from 'react';
import { getData } from '../api/apiService';
import { useStateContext } from '../contexts/ContextProvider';

export const useCategories = () => {
    const { categories, setCats, currentUser } = useStateContext()
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);



    const refresh = async () => {
        setLoading(true);
        try {
            const { data } = await getData('categories');
            setCats(data);
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (currentUser) {
            if (categories.parents.length > 0) {
                return;
            }
            refresh();
        }
    }, [currentUser]);


    return { categories, loading, error, refresh };
};
